import { render, staticRenderFns } from "./RoomDataAgeProfile.vue?vue&type=template&id=66ad1f58&"
import script from "./RoomDataAgeProfile.vue?vue&type=script&lang=ts&"
export * from "./RoomDataAgeProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports